export const home = {
  // Hero
  hero_eyebrow: 'GUIA INDEPENDENTE \u2022 ATUALIZADO EM 2026',
  hero_h1: 'CSSBuy Spreadsheet: Encontre Produtos, Links e Guias CSSBuy',
  hero_description: 'Explore um guia independente do CSSBuy Spreadsheet com produtos organizados, categorias, informa\u00e7\u00f5es de QC, envio, avalia\u00e7\u00f5es, compara\u00e7\u00f5es e dicas pr\u00e1ticas para compradores.',
  hero_cta_primary: 'Explorar CSSBuy Spreadsheet',
  hero_cta_secondary: 'Ver Guias CSSBuy',
  hero_trust: 'Informa\u00e7\u00e3o independente \u2022 Guias pr\u00e1ticos \u2022 Conte\u00fado organizado',

  // Categories
  categories_title: 'Categorias populares do CSSBuy Spreadsheet',
  categories_cta: 'Ver produtos',
  cat_shoes: 'T\u00eanis',
  cat_hoodies: 'Hoodies/Sweaters',
  cat_tshirts: 'Camisetas',
  cat_jackets: 'Jaquetas',
  cat_pants: 'Cal\u00e7as/Shorts',
  cat_headwear: 'Bon\u00e9s',
  cat_sets: 'Conjuntos',
  cat_underwear: 'Underwear',
  cat_jersey: 'Jerseys',
  cat_accessories: 'Acess\u00f3rios',
  cat_bags: 'Bolsas',
  cat_belts: 'Cintos',
  cat_perfumes: 'Perfumes',
  cat_other: 'Outros',

  // What is
  whatis_title: 'O que \u00e9 o CSSBuy Spreadsheet?',
  whatis_text: 'O CSSBuy Spreadsheet \u00e9 uma forma organizada de descobrir e comparar produtos, links e recursos relacionados ao CSSBuy. Em vez de procurar informa\u00e7\u00f5es espalhadas por diferentes p\u00e1ginas, voc\u00ea pode explorar categorias, consultar guias de QC e encontrar informa\u00e7\u00f5es \u00fateis sobre envio e compra em um s\u00f3 lugar.',
  whatis_cta: 'Explorar o Spreadsheet',

  // How it works
  howitworks_title: 'Como usar o CSSBuy Spreadsheet',
  step1_title: 'Pesquise',
  step1_desc: 'Encontre uma categoria ou produto.',
  step2_title: 'Compare',
  step2_desc: 'Compare informa\u00e7\u00f5es e links dispon\u00edveis.',
  step3_title: 'Verifique',
  step3_desc: 'Confira vendedor, pre\u00e7o, op\u00e7\u00f5es e QC.',
  step4_title: 'Decida',
  step4_desc: 'Fa\u00e7a sua pr\u00f3pria verifica\u00e7\u00e3o antes de comprar.',

  // Guides
  guides_title: 'Guias CSSBuy mais populares',
  guide_review: 'CSSBuy Review',
  guide_shipping: 'CSSBuy Shipping Cost',
  guide_warehouse: 'CSSBuy Warehouse',
  guide_qc: 'CSSBuy QC',
  guide_coupon: 'CSSBuy Coupon',
  guide_legit: 'CSSBuy Legit',

  // Safety
  safety_title: 'Centro de Segurança CSSBuy',
  safety_notice: 'IMPORTANT SAFETY NOTICE',
  safety_disclaimer: 'This is an independent informational website. It is not the official CSSBuy website. We do not process payments, orders, refunds or shipping.',
  safety_verify_urls: 'Verificar URLs',
  safety_verify_sellers: 'Verificar vendedores',
  safety_verify_price: 'Verificar pre\u00e7o atual',
  safety_verify_qc: 'Verificar QC',
  safety_verify_shipping: 'Verificar envio',
  safety_payments: 'Evitar pagamentos suspeitos',
  safety_passwords: 'N\u00e3o compartilhar senhas',
  safety_customs: 'Verificar regras alfandeg\u00e1rias',
  safety_small_orders: 'Come\u00e7ar com pedidos pequenos',

  // Featured
  featured_title: 'CSSBuy Spreadsheet em destaque',
  featured_product: 'Produto',
  featured_category: 'Categoria',
  featured_platform: 'Plataforma',
  featured_seller: 'Vendedor',
  featured_qc: 'QC',
  featured_updated: 'Atualiza\u00e7\u00e3o',
  featured_action: 'A\u00e7\u00e3o',
  featured_verify: 'Verificar informa\u00e7\u00f5es atuais',
  featured_cta: 'Ver todos os produtos',

  // FAQ
  faq_title: 'Perguntas Frequentes',
  faq_q1: 'O que \u00e9 CSSBuy Spreadsheet?',
  faq_a1: 'CSSBuy Spreadsheet \u00e9 um guia organizado de recursos, produtos e links relacionados ao CSSBuy.',
  faq_q2: 'Como funciona o CSSBuy Spreadsheet?',
  faq_a2: 'Voc\u00ea navega por categorias, encontra produtos e links, e consulta guias de compra.',
  faq_q3: 'O CSSBuy Spreadsheet \u00e9 gratuito?',
  faq_a3: 'Sim, este \u00e9 um recurso informativo independente e gratuito.',
  faq_q4: 'Como verificar um produto CSSBuy?',
  faq_a4: 'Consulte guias de QC e verifique vendedores antes de comprar.',
  faq_q5: 'O CSSBuy \u00e9 leg\u00edtimo?',
  faq_a5: 'CSSBuy \u00e9 uma plataforma conhecida. Verifique sempre vendedores e links antes de comprar.',
  faq_q6: 'Como funciona o envio CSSBuy?',
  faq_a6: 'O envio depende de peso, volume, destino e linha de envio escolhida.',
  faq_q7: 'Como funciona o QC do CSSBuy?',
  faq_a7: 'QC significa Quality Control. \u00c9 o processo de verifica\u00e7\u00e3o dos produtos antes do envio.',
  faq_q8: 'Quanto custa o envio CSSBuy?',
  faq_a8: 'O custo depende de v\u00e1rios fatores. Verifique informa\u00e7\u00f5es atuais no site oficial.',

  // Final CTA
  final_cta_title: 'Explore o CSSBuy Spreadsheet e encontre guias e recursos organizados para sua pesquisa.',
  final_cta_button: 'Explorar CSSBuy Spreadsheet',

  // Buttons
  btn_cssbuy_spreadsheet: 'CSSBuy Spreadsheet',
  btn_buy_it_now: 'Buy It Now',

  // Footer
  footer_tagline: 'Recurso independente de informa\u00e7\u00e3o. N\u00e3o afiliado ou endossado pela CSSBuy.',
  footer_links: 'Links',
  footer_legal: 'Legal',
  footer_spreadsheet: 'CSSBuy Spreadsheet',
  footer_guides: 'Guias',
  footer_reviews: 'Avalia\u00e7\u00f5es',
  footer_shipping: 'Envio',
  footer_coupon: 'Cupons',
  footer_warehouse: 'Warehouse',
  footer_qc: 'QC',
  footer_safety: 'Seguran\u00e7a',
  footer_comparison: 'Compara\u00e7\u00e3o',
  footer_faq: 'FAQ',
  footer_about: 'Sobre',
  footer_contact: 'Contato',
  footer_privacy: 'Privacidade',
  footer_terms: 'Termos',
  footer_disclaimer: 'Disclaimer',
  footer_languages: 'Idiomas',
  footer_lang_pt: 'Portugu\u00eas',
  footer_lang_de: 'Deutsch',
  footer_lang_en: 'English',

  // Nav
  nav_spreadsheet: 'Spreadsheet',
  nav_categories: 'Categorias',
  nav_guides: 'Guias',
  nav_reviews: 'Avalia\u00e7\u00f5es',
  nav_shipping: 'Envio',
  nav_safety: 'Seguran\u00e7a',
  nav_language: 'Idioma',
  nav_home: 'Início',
  nav_shopping_guide: 'Guia de Compras',
  mobile_categories_title: 'Categorias',
  pillar_title: 'Guias Principais do CSSBuy Spreadsheet',

  // Search
  search_placeholder: 'Pesquisar no CSSBuy Spreadsheet...',
  search_filter_category: 'Categoria',
  search_filter_platform: 'Plataforma',
  search_filter_product: 'Produto',
  search_filter_seller: 'Vendedor',
  search_filter_qc: 'QC',
  search_filter_updated: 'Atualiza\u00e7\u00e3o',
  search_btn: 'Pesquisar',
  search_find_fast: 'Encontre rapidamente o que procura',

  // Disclaimer
  independent_notice: 'Independent informational resource. Not the official CSSBuy website.',
};